import Http from '../../../../network/Http';
import {NatGetCampaign} from './NatGetCampaign';

export default class NatCampaignRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http;
    }

    // キャンペーン情報取得
    async getCampaignBanner(): Promise<NatGetCampaign> {
        return await this.http.get('/api/resident/campaigns');
    }
}